import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";
// import { ModosOp} from "../../../isp._comun/iu/_principal/constantesIuPrin";
import { DialogType, ModosOp} from "../../../isp._comun/iu/_principal/constantesIuPrin";
import getEstadoInicial from "../EstadoDialogoAsociado";

export default class VentanaAsociado extends Ventana {
    constructor(estadoComp) {
        super();
        this.id= DialogType.ASOCIADO+estadoComp.domain.screen.idAsociado;
        // this.id= VentanaAsociado.name+estadoComp.domain.screen.idAsociado;
        this.estadoComp = estadoComp;
        // this.id= estadoComp.flag.modoOperacion+estadoComp.domain.screen.idAsociado;
        // this.id= this.estadoComp.flag.modoOperacion+this.estadoComp.domain.screen.idAsociado;
        /* this.estadoCom = {
            domain: {
                screen: {
                    idAsociado: null,
                },
            },
            flag: {
                modoOperacion: ModosOp.CREAR,
                modal: false,
                cargandoEntidad: false,
            },
        }; */
        // this.dispatch = null;
        // this.ventanaCargando=null
    }

    static nuevaVentanaEnModoCrear() {
        return new VentanaAsociado(getEstadoInicial());
    }

    static nuevaVentanaEnModoOk(idAsociado) {
        const estadoComp = getEstadoInicial();
        estadoComp.flag.modoOperacion = ModosOp.OK;
        estadoComp.domain.screen.idAsociado = idAsociado;
        estadoComp.flag.modal = true;
        estadoComp.flag.cargandoEntidad = true;
        return new VentanaAsociado(estadoComp);
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaAsociado)) {
            return false;
        }

        if(this.id === ventanaAAbrir.id){
            return true;
        }

        /* if (
            this.estadoComp.flag.modoOperacion === ModosOp.CREAR &&
            ventanaAAbrir.estadoComp.flag.modoOperacion === ModosOp.CREAR
        ) {
            return true;
        }

        if (
            this.estadoComp.flag.modoOperacion !== ModosOp.CREAR &&
            ventanaAAbrir.estadoComp.flag.modoOperacion !== ModosOp.CREAR &&
            this.estadoComp.domain.screen.idAsociado ===
                ventanaAAbrir.estadoComp.domain.screen.idAsociado
        ) {
            return true;
        } */

        return false;
    }

    clonar() {
        const nuevaVentana = new VentanaAsociado(this.estadoComp);
        nuevaVentana.posicionZ = this.posicionZ;
        // nuevaVentana.id = this.id;
        // nuevaVentana.estadoComp = this.estadoComp;
        // nuevaVentana.dispatch = this.dispatch;
        // nuevaVentana.ventanaCargando = this.ventanaCargando
        return nuevaVentana;
    }
}
